import {
  faCancel,
  faCheck,
  faHourglassStart,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function classNames(...classes: string[]) {
  return classes.filter(Boolean)?.join(' ') ?? ' '
}

const getColorStatus = (value: string | null) => {
  switch (value) {
    case 'CREATED':
      return 'bg-[#bfd7fe] text-[#1e55af]'

    case 'PENDING_TO_ARRIVE':
      return 'bg-yellow-100 text-yellow-800'

    case 'ARRIVED':
      return 'bg-green-100 text-green-800'

    case 'CANCELLED':
      return 'bg-red-100 text-red-800'

    default:
      return 'bg-gray-100 text-gray-800'
  }
}

const getStatusIcon = (status: string) => {
  switch (status) {
    case 'CREATED':
      return faCheck

    case 'PENDING_TO_ARRIVE':
      return faHourglassStart

    case 'ARRIVED':
      return faCheck

    case 'CANCELLED':
      return faCancel

    default:
      return faHourglassStart
  }
}

const getStatusLabel = (status: string) => {
  switch (status) {
    case 'CREATED':
      return 'Creado'

    case 'PENDING_TO_ARRIVE':
      return 'Pendiente de arribo'

    case 'ARRIVED':
      return 'Arribado'

    case 'CANCELLED':
      return 'Cancelado'

    default:
      return status
  }
}

interface ShipmentStatusBadgeProps {
  status?: string
  showIcon?: boolean
  onlyShowIcon?: boolean
  className?: string
}

export default function ShipmentStatusBadge({
  status,
  showIcon = true,
  onlyShowIcon,
  className = '',
}: ShipmentStatusBadgeProps) {
  if (!status) return <></>

  return (
    <div
      className={classNames(
        getColorStatus(status),
        'inline-flex flex-shrink-0 items-center rounded-full px-2.5 py-0.5 text-sm font-medium',
        className
      )}
    >
      {showIcon && (
        <FontAwesomeIcon
          className="mr-1.5 flex-shrink-0 align-middle"
          icon={getStatusIcon(status)}
        />
      )}
      {!onlyShowIcon && (
        <span className="min-w-0 truncate">{getStatusLabel(status)}</span>
      )}
    </div>
  )
}
